import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito cocinar cosas complicadas?',
  answer: 'No, son alimentos sencillos que encuentras en cualquier mercado local. La guía se enfoca en comida real y accesible.'
}, {
  question: '¿Puedo tomar café?',
  answer: 'Sí, pero nunca solo ni en ayunas. Acompáñalo de grasa (un poco de coco o mantequilla clarificada) o tómalo después del desayuno para evitar el pico de cortisol.'
}, {
  question: '¿Qué pasa si tengo un evento social?',
  answer: 'Aplica la regla 80/20. Si el 80% de tu semana sigue el protocolo, el 20% restante no arruinará tus resultados. Disfruta sin culpa y retoma al día siguiente.'
}, {
  question: '¿Tengo que contar calorías?',
  answer: 'No. En el Metabolismo Silver contamos nutrientes y medimos horarios. Las calorías estresan; la nutrición sana.'
}, {
  question: '¿Cuánto tiempo toma ver resultados?',
  answer: 'La mayoría nota una reducción en la inflamación abdominal en los primeros 4 a 5 días. A los 21 días, verás cambios significativos en energía y cómo te queda la ropa.'
}, {
  question: '¿Es seguro si tengo problemas de tiroides?',
  answer: 'Sí, el plan se enfoca en nutrición real, pero siempre recomendamos consultarlo con tu médico antes de iniciar cualquier cambio en tu alimentación.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí, un solo pago con acceso de por vida a la guía. Sin suscripciones ni cargos recurrentes.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 md:py-24 bg-white" data-id="element-44">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-12 text-center" data-id="element-46">
          Preguntas Frecuentes
        </motion.h2>
        <div className="space-y-4" data-id="element-47">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-sage-primary/30 rounded-lg overflow-hidden" data-id="element-48">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-sage-primary/5 transition-colors" data-id="element-49">
                <span className="font-semibold text-forest pr-4" data-id="element-50">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-sage-dark flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-51" />
              </button>
              <AnimatePresence data-id="element-52">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-53">
                    <div className="px-6 pb-6 text-forest/70 leading-relaxed" data-id="element-54">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}